// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"sidebar_activeTab__1zNEA","arrow":"sidebar_arrow__t8Eb6"};